{
	"app_fallbacks": {
		"error": {
			"description": "Si è verificato un errore imprevisto durante il rendering di questa pagina. Puoi riprovare oppure tornare a un'area funzionante dell'app.",
			"title": "Qualcosa è andato storto."
		},
		"go_back": "Indietro",
		"go_home": "Vai alla home",
		"loading": "Caricamento",
		"not_found": {
			"description": "La pagina che stai cercando non esiste o potrebbe essere stata spostata. Torna a un'area funzionante dell'app.",
			"title": "Pagina non trovata."
		},
		"try_again": "Riprova"
	},
	"app_sidebar": {
		"brand_logo_alt": "Logo di {{product}}",
		"console_name": "Backoffice",
		"menu": {
			"logout": "Esci",
			"preferences": "Preferenze"
		}
	}
}
